/* assets/swm26-modul-produkt.js */
(() => {
  const roots = document.querySelectorAll('[data-swm26-pm]');
  if (!roots.length) return;

  // Modal kann im DOM ausserhalb von [data-swm26-pm] liegen,
  // daher zuerst in root suchen, dann global als Fallback.
  const findModal = (root) =>
    root.querySelector('[data-pm-modal]') || document.querySelector('[data-pm-modal]');

  const findIframe = (root) =>
    root.querySelector('[data-pm-modal-iframe]') || document.querySelector('[data-pm-modal-iframe]');

  const lockScroll = () => {
    document.documentElement.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    document.documentElement.style.overflow = '';
  };

  const openModal = (root, url) => {
    const modal = findModal(root);
    const iframe = findIframe(root);
    if (!modal || !iframe || !url) return;

    modal.classList.remove('is-ready');
    iframe.src = 'about:blank';

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();

    // cleanup previous listeners/timers
    if (iframe._pmOnLoad) {
      iframe.removeEventListener('load', iframe._pmOnLoad);
      iframe._pmOnLoad = null;
    }
    if (iframe._pmReadyTimer) {
      window.clearTimeout(iframe._pmReadyTimer);
      iframe._pmReadyTimer = null;
    }

    const onLoad = () => {
      iframe._pmReadyTimer = window.setTimeout(() => {
        modal.classList.add('is-ready');
      }, 350);

      iframe.removeEventListener('load', onLoad);
      iframe._pmOnLoad = null;
    };

    iframe._pmOnLoad = onLoad;
    iframe.addEventListener('load', onLoad);

    requestAnimationFrame(() => {
      iframe.src = url;
    });
  };

  const closeModal = (root) => {
    const modal = findModal(root);
    const iframe = findIframe(root);
    if (!modal || !iframe) return;

    modal.classList.remove('is-open', 'is-ready');
    modal.setAttribute('aria-hidden', 'true');

    if (iframe._pmReadyTimer) {
      window.clearTimeout(iframe._pmReadyTimer);
      iframe._pmReadyTimer = null;
    }
    if (iframe._pmOnLoad) {
      iframe.removeEventListener('load', iframe._pmOnLoad);
      iframe._pmOnLoad = null;
    }

    iframe.src = 'about:blank';
    unlockScroll();
  };

  const bindModalClose = (root) => {
    const modal = findModal(root);
    if (!modal) return;

    modal.querySelectorAll('[data-pm-modal-close]').forEach((el) => {
      if (el.dataset.pmBoundClose === '1') return;
      el.dataset.pmBoundClose = '1';
      el.addEventListener('click', () => closeModal(root));
    });

    if (modal.dataset.pmBoundBackdrop === '1') return;
    modal.dataset.pmBoundBackdrop = '1';

    modal.addEventListener('click', (e) => {
      if (e.target && e.target.classList && e.target.classList.contains('swm26-pm__modal-backdrop')) {
        closeModal(root);
      }
    });
  };

  const bindNutritionTriggers = (root, scope) => {
    const container = scope || root;

    container.querySelectorAll('button[data-nutrition-url]').forEach((btn) => {
      if (btn.dataset.pmBoundNutri === '1') return;
      btn.dataset.pmBoundNutri = '1';

      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        openModal(root, btn.getAttribute('data-nutrition-url'));
      });
    });

    container.querySelectorAll('a[href*="winestro.info/?s="]').forEach((a) => {
      if (a.dataset.pmBoundNutri === '1') return;
      a.dataset.pmBoundNutri = '1';

      a.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        openModal(root, a.getAttribute('href'));
      });
    });
  };

  const bindHardWinestroBlocker = (root) => {
    if (root.dataset.pmHardBound === '1') return;
    root.dataset.pmHardBound = '1';

    root.addEventListener(
      'click',
      (ev) => {
        const a = ev.target && ev.target.closest ? ev.target.closest('a[href*="winestro.info/?s="]') : null;
        if (!a) return;

        ev.preventDefault();
        ev.stopPropagation();
        openModal(root, a.getAttribute('href'));
      },
      true
    );
  };

  const clampQty = (v) => {
    const n = parseInt(v, 10);
    if (Number.isNaN(n) || n < 1) return 1;
    return n;
  };

  roots.forEach((root) => {
    // Modal
    bindModalClose(root);
    bindHardWinestroBlocker(root);
    bindNutritionTriggers(root, root);

    // Qty +/-
    const qtyInput = root.querySelector('[data-pm-qty-input]');
    const btnMinus = root.querySelector('[data-pm-qty-minus]');
    const btnPlus = root.querySelector('[data-pm-qty-plus]');

    btnMinus?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, clampQty(qtyInput.value) - 1));
    });

    btnPlus?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(clampQty(qtyInput.value) + 1);
    });

    // Image gallery next
    const imgSlides = Array.from(root.querySelectorAll('[data-pm-imgslide]'));
    const btnImgNext = root.querySelector('[data-pm-img-next]');
    if (imgSlides.length > 1 && btnImgNext) {
      let imgIndex = imgSlides.findIndex((s) => s.classList.contains('is-active'));
      if (imgIndex < 0) imgIndex = 0;

      const setImg = (next) => {
        imgSlides[imgIndex]?.classList.remove('is-active');
        imgIndex = (next + imgSlides.length) % imgSlides.length;
        imgSlides[imgIndex]?.classList.add('is-active');
      };

      btnImgNext.addEventListener('click', () => setImg(imgIndex + 1));
    }

    // SWM Add-to-cart -> trigger hidden theme form submit (drawer logic)
    const swmBtn = root.querySelector('[data-swm26-add-to-cart]');
    const legacyQty =
      root.querySelector('.swm26-pm__legacy input[name="quantity"]') ||
      root.querySelector('.swm26-pm__legacy [data-quantity-input]');

    const legacySubmit =
      root.querySelector('.swm26-pm__legacy [data-add-to-cart-trigger]') ||
      root.querySelector('.swm26-pm__legacy button[name="add"]') ||
      root.querySelector('.swm26-pm__legacy button[type="submit"]') ||
      root.querySelector('.swm26-pm__legacy input[type="submit"]');

    swmBtn?.addEventListener('click', () => {
      if (!legacySubmit) return;

      // sync quantity into legacy form (if present)
      if (legacyQty && qtyInput) legacyQty.value = String(clampQty(qtyInput.value));

      // trigger real theme submit (ajax -> drawer)
      legacySubmit.click();
    });

    // Keyboard: ESC closes modal
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal(root);
    });
    root.tabIndex = 0;
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-swm26-pm]').forEach((root) => {
      const modal = findModal(root);
      if (modal && modal.classList.contains('is-open')) closeModal(root);
    });
  });
})();